// Channel names + per-layout slot styles for the persistent search map.
// The map node fills its slot 100%; the slot owns positioning (former
// reusableMapStyles layout classes, relocated here). `theme.tokens.topbarHeightDesktop`
// mirrors the old var(--topbarHeightDesktop); breakpoints mirror 600/900/1200.

export const MAP_CHANNELS = {
  SEARCH: 'search',
  BOOKMARK: 'bookmark',
};

// former SearchPage.module.css .map — fixed map column over the reserved right space
const searchColumn = (theme) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  width: '100%',
  height: 'calc(100vh - 80px)',
  [theme.breakpoints.up('sm')]: { width: '100%' },
  [theme.breakpoints.up('md')]: { width: '50%' },
  [theme.breakpoints.up('lg')]: {
    top: theme.tokens.topbarHeightDesktop,
    width: '38%',
    height: `calc(100vh - ${theme.tokens.topbarHeightDesktop})`,
  },
});

// former SearchPage.module.css .mapStoryblokComponent — in-flow sticky column.
// Fills its column (width 100%) rather than viewport units: the ModalInMobile panel is
// constrained to ~38% in searchPageContentStyles and the map fills that panel, so it is not
// centered with empty gaps (cf. fix 132f729fc). `top` is the topbar height so sticky engages.
const storyblok = (theme) => ({
  width: '100%',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    height: `calc(100vh - ${theme.tokens.topbarHeightDesktop})`,
    top: theme.tokens.topbarHeightDesktop,
    position: 'sticky',
  },
});

// former BookmarkPage.module.css .bookmarkMap — fills its column (width 100%) rather than
// viewport units (cf. storyblok fix a66ab34e9): bookmarkPageStyles constrains the ModalInMobile
// panel to 50%/37.5% and the map fills that panel, so it is not centered with empty gaps.
// `position: sticky` keeps it in view while the list scrolls, matching the SearchPage map.
const bookmark = (theme) => ({
  width: '100vw',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    position: 'sticky',
    top: theme.tokens.topbarHeightDesktop,
    width: '100%',
    height: `calc(100vh - ${theme.tokens.topbarHeightDesktop})`,
  },
});

export const MAP_SLOT_LAYOUT_SX = { searchColumn, storyblok, bookmark };
